var $ = jQuery;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

//on screen fix button js start
function isOnScreen(elem) {
  // if the element doesn't exist, abort
  if (elem.length == 0) {
    return;
  }
  var $window = jQuery(window)
  var viewport_top = $window.scrollTop()
  var viewport_height = $window.height()
  var viewport_bottom = viewport_top + viewport_height
  var $elem = jQuery(elem)
  var top = $elem.offset().top
  var height = $elem.height()
  var bottom = top + height

  return (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}
//on screen fix button js end

$(document).ready(function () {

  if (isOnScreen($(".nonStickyBtn").eq(0)) ||
      isOnScreen($(".nonStickyBtn").eq(1)) ||
      isOnScreen($(".nonStickyBtn").eq(2)) ||
      isOnScreen($(".nonStickyBtn").eq(3)) ||
      isOnScreen($(".nonStickyBtn").eq(4)) ||
      isOnScreen($("#product"))) {
    $(".stickyBtn").fadeOut(10);
  } else {
    // $(".stickyBtn").fadeIn(10);
    if ($(window).width() < 767) {
      $(".stickyBtn").fadeIn(10);
    }
  }
  $(window).on('scroll', function () {
    if (isOnScreen($(".nonStickyBtn").eq(0)) ||
        isOnScreen($(".nonStickyBtn").eq(1)) ||
        isOnScreen($(".nonStickyBtn").eq(2)) ||
        isOnScreen($(".nonStickyBtn").eq(3)) ||
        isOnScreen($(".nonStickyBtn").eq(4)) ||
        isOnScreen($("#product"))) {
      $(".stickyBtn").fadeOut(10);
    } else {
      // $(".stickyBtn").fadeIn(10);
      if ($(window).width() < 767) {
        $(".stickyBtn").fadeIn(10);
      }
    }
  });
});


$(document).ready(function () {
  onload_set_pricing_2();
  onload_set_pricing_1();
  $('.pack-three .first-variant input[type="radio"]').prop("checked", true).trigger("click");
  set_pricing_3();

  /* scroll to target */
  jQuery('.scrollTo').click(function (e) {
    var jump = jQuery(this).attr('href');
    var new_position = jQuery(jump).offset();
    var scroll = 20;
    jQuery('html, body').stop().animate({
      scrollTop: new_position.top + scroll
    }, 800, function () {
      var new_position = jQuery(jump).offset();
      jQuery('html, body').stop().animate({
        scrollTop: new_position.top + scroll
      }, 800);
    });
    e.preventDefault();
  });

  jQuery('.lpg-02-header__nav-menu li a').click(function (e) {
    var jump = jQuery(this).attr('href');
    var new_position = jQuery(jump).offset();
    var scroll = 20;
    jQuery('html, body').stop().animate({
      scrollTop: new_position.top + scroll
    }, 800, function () {
      var new_position = jQuery(jump).offset();
      jQuery('html, body').stop().animate({
        scrollTop: new_position.top + scroll
      }, 800);
    });
    e.preventDefault();
  });

  // initialize match Height
  $(".fancybox").fancybox({
    touch: false
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })


  /* slider for */
  if ($('.lpg-02-product__slider-for').length) {
    $('.lpg-02-product__slider-for').slick({
      fade: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: 'progressive',
      asNavFor: '.lpg-02-product__slider-nav',
      responsive: [{
        breakpoint: 768,
        settings: {
          arrows: true,
        }
      },

                  ]
    });
  }

  if ($('.lpg-02-product__slider-nav').length) {
    $('.lpg-02-product__slider-nav').slick({
      dots: false,
      slidesToShow: 5,
      centerMode: false,
      slidesToScroll: 1,
      focusOnSelect: true,
      lazyLoad: 'progressive',
      asNavFor: '.lpg-02-product__slider-for',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
                   {
                     breakpoint: 992,
                     settings: {
                       slidesToShow: 5,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 768,
                     settings: {
                       infinite: false,
                       slidesToShow: 4,
                       slidesToScroll: 1,
                     }
                   },
                   {
                     breakpoint: 479,
                     settings: {
                       slidesToShow: 3,
                       slidesToScroll: 1,
                     }
                   }
                  ]
    });
  }

  if ($('.lpg-02-testimonial__slider').length > 0) {
    $('.lpg-02-testimonial__slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
                   {
                     breakpoint: 768,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                       adaptiveHeight:true,
                     }
                   },
                   {
                     breakpoint: 479,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                       adaptiveHeight:true,
                     }
                   }
                  ]
    });
  }

  if ($('.lpg-02-testimonial__slider--style-2').length > 0) {
    $('.lpg-02-testimonial__slider--style-2').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      responsive: [{
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
                   {
                     breakpoint: 768,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '60px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                       adaptiveHeight:true,
                     }
                   },
                   {
                     breakpoint: 479,
                     settings: {
                       infinite: true,
                       centerMode: true,
                       centerPadding: '30px',
                       slidesToShow: 1,
                       slidesToScroll: 1,
                       adaptiveHeight:true,
                     }
                   }
                  ]
    });
  }

  //     if($('.lpg-02-product__purchase-input').length > 0) {
  //         $('.lpg-02-product__purchase-input').on('click',function() {
  //             if($('#lpg-02-subscribesave').is(':checked')) {
  //                 $('#js-product__dropdown-delivery').slideDown();
  //             }
  //             else {
  //                 $('#js-product__dropdown-delivery').slideUp();
  //             }
  //         })
  //     }


  if ($('.js-nav-toggle').length > 0) {
    $('.js-nav-toggle').click(function () {
      $('.lpg-02-header__nav-menu').slideToggle();
    });
  }

  if ($(window).width() < 768) {
    if ($('.lpg-02-header__nav-menu li a').length > 0) {
      $('.lpg-02-header__nav-menu li a').click(function () {
        $('.lpg-02-header__nav-menu').slideUp();
      });
    }
  }

  /* $(document).on('change', 'select,input[type="radio"]', function () {
    set_pricing_1();
    set_pricing_2();
    set_pricing_3();
    changeMySlider();
  });*/

  $(document).on('change', 'select,.pack1 input[type="radio"]', function (){
    $('.pack-one .first-variant input[type="radio"]').prop("checked", true).trigger("click");
    set_pricing_1();
    changeMySlider();
  });
  $(document).on('change', 'select,.pack2 input[type="radio"]', function (){
    $('.pack-two .first-variant input[type="radio"]').prop("checked", true).trigger("click");
    set_pricing_2();
    changeMySlider();
  });
  $(document).on('change', 'select,.pack3 input[type="radio"]', function (){
    $('.pack-three .first-variant input[type="radio"]').prop("checked", true).trigger("click");
    set_pricing_3();
    changeMySlider();
  });

  $(document).on('change', 'select,.pack-one input[type="radio"]', function (){
    set_pricing_1();
    changeMySlider();
  });
  $(document).on('change', 'select,.pack-two input[type="radio"]', function (){
    set_pricing_2();
    changeMySlider();
  });
  $(document).on('change', 'select,.pack-three input[type="radio"]', function (){
    set_pricing_3();
    changeMySlider();
  });



  $(document).on('change', '.lpg-02-product__purchase-radio input[type="radio"]', function (){
    onload_set_pricing_2();
    onload_set_pricing_1();
    $('.pack3 input[type="radio"]').prop("checked", true).trigger("click");
    $('.pack-three .first-variant input[type="radio"]').prop("checked", true).trigger("click");
    set_pricing_3();
  });

  $(document).on('click', '[data-atc-js]', function (e) {
    e.preventDefault();
    let is_otp = true;
    if ($(".lpg-02-product__purchase-input:checked").val() !== "otp") {
      is_otp = false;
    }
    let quantity = $(`[name="lpg02product__quantity"]:checked`).val();
    let variant_id = $(`[name="lpg02product__flavour"]:checked`).val();
    let subscription_variant_id = $(`[name="lpg02product__flavour"]:checked`).attr('data-sub_variant_id');
    let subscription_id = $(`[name="lpg02product__flavour"]:checked`).attr('data-subscription_id');
    let subscription_frequency = $(`#js-product__dropdown-delivery select`).val();
    let subscription_unit_type = "days";
    let item = {};
    item.quantity = quantity;
    if (is_otp) {
      item.id = variant_id;
    } else {
      item.id = subscription_variant_id;
      let properties = {};
      properties['subscription_id'] = subscription_id;
      properties['shipping_interval_unit_type'] = subscription_unit_type;
      properties['shipping_interval_frequency'] = subscription_frequency;
      item.properties = properties;
    }
    $.ajax({
      url: "/cart/add.js",
      data: item,
      method: "POST",
      dataType: "JSON",
      success: function (data) {
        if (is_otp) {
          window.location = "/checkout";
        } else {
          // Build the Checkout URL
          var myshopify_domain = 'nutriseeduk.myshopify.com';
          var token = reChargeGetCookie('cart');
          try {
            // Cross-domain tracking with Google Analytics
            var ga_linker = ga.getAll()[0].get('linkerParam');
          } catch (e) {
            // 'ga' is not available
            var ga_linker = '';
          }
          // Customer email address for use in the Checkout URL
          var customer_param = '';
          var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token=' + token + '&' + ga_linker + '&' + customer_param
          window.rcurl = checkout_url;
          window.location = window.rcurl;
        }
      },
      error: function (data) {
        window.alert(data.responseJSON.description);
      }
    });
  });
});

$(window).on('resize', function () {
  if ($(window).width() < 768) {
    if ($('.lpg-02-header__nav-menu li a').length > 0) {
      $('.lpg-02-header__nav-menu li a').click(function () {
        $('.lpg-02-header__nav-menu').slideUp();
      });
    }
  }
})
// 29july changes//
$(document).ready(function () {
  if ($(window).width() < 768) {
    if ($('.lpg-02-product__purchase-input').length > 0) {
      $('#lpg-02-subscribesave').on('click', function () {
        if ($('#lpg-02-subscribesave').is(':checked')) {
          $('.lpg-02-product__selection-inner').slideToggle();
          $('#js-product__dropdown-delivery').slideDown();
        } else {

          $('#js-product__dropdown-delivery').slideUp();
        }
      })
      $('#lpg-02-onetimepurchase').on('click', function () {
        if ($('#lpg-02-onetimepurchase').is(':checked')) {
          $('.lpg-02-product__selection-inner').slideToggle();
          $('#js-product__dropdown-delivery').slideUp();

        } else {

          $('#js-product__dropdown-delivery').slideUp();
        }
      })

    }
  } else {
    if ($('.lpg-02-product__purchase-input').length > 0) {
      $('.lpg-02-product__purchase-input').on('click', function () {
        if ($('#lpg-02-subscribesave').is(':checked')) {
          $('#js-product__dropdown-delivery').slideDown();
        } else {
          $('#js-product__dropdown-delivery').slideUp();
        }
      })
    }
  }
});


function set_pricing_1() {
  let otp_price = $(`.pack-one [name="lpg02product__flavour"]:checked`).attr('data-price');
  let subscription_price = $(`.pack-one [name="lpg02product__flavour"]:checked`).attr('data-subscription_price');
  let imagepath = $(`.pack-one [name="lpg02product__flavour"]:checked`).attr('data-image');
  let is_otp = true;
  if ($(".lpg-02-product__purchase-input:checked").val() !== "otp") {
    is_otp = false;
  }

  $(".pack1.lpg-02-product__item").each(function (ix, em) {

    let quantity = 1;
    let data_per_pack = otp_price;
    let data_total = otp_price * quantity;
    data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
    data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    if (is_otp == false) {
      data_per_pack = subscription_price;
      data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
      data_total = subscription_price * quantity;
      data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    }
    $(".lpg-02-section__subtitle").find('[data-perpack]').html(data_per_pack);

    $(em).find('[data-perpack]').html(data_per_pack);
    $(em).find('[data-total]').html(data_total);

  });
}

function set_pricing_2() {
  let otp_price = $(`.pack-two [name="lpg02product__flavour"]:checked`).attr('data-price');
  let subscription_price = $(`.pack-two [name="lpg02product__flavour"]:checked`).attr('data-subscription_price');
  let imagepath = $(`.pack-two [name="lpg02product__flavour"]:checked`).attr('data-image');
  let is_otp = true;
  if ($(".lpg-02-product__purchase-input:checked").val() !== "otp") {
    is_otp = false;
  }

  $(".pack2.lpg-02-product__item").each(function (ix, em) {

    let quantity = 2;
    let data_per_pack = otp_price;
    let data_total = otp_price * quantity;
    data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
    data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    if (is_otp == false) {
      data_per_pack = subscription_price;
      data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
      data_total = subscription_price * quantity;
      data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    }
    $(".lpg-02-section__subtitle").find('[data-perpack]').html(data_per_pack);

    $(em).find('[data-perpack]').html(data_per_pack);
    $(em).find('[data-total]').html(data_total);

  });
}

function set_pricing_3() {
  let otp_price = $(`.pack-three [name="lpg02product__flavour"]:checked`).attr('data-price');
  let subscription_price = $(`.pack-three [name="lpg02product__flavour"]:checked`).attr('data-subscription_price');
  let imagepath = $(`.pack-three [name="lpg02product__flavour"]:checked`).attr('data-image');
  let is_otp = true;
  if ($(".lpg-02-product__purchase-input:checked").val() !== "otp") {
    is_otp = false;
  }

  $(".pack3.lpg-02-product__item").each(function (ix, em) {

    let quantity = 3;
    let data_per_pack = otp_price;
    let data_total = otp_price * quantity;
    data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
    data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    if (is_otp == false) {
      data_per_pack = subscription_price;
      data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
      data_total = subscription_price * quantity;
      data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    }
    $(".lpg-02-section__subtitle").find('[data-perpack]').html(data_per_pack);

    $(em).find('[data-perpack]').html(data_per_pack);
    $(em).find('[data-total]').html(data_total);

  });
}


function onload_set_pricing_1() {
  $('.pack-one .first-variant input[type="radio"]').prop("checked", true).trigger("click");
  let otp_price = $(`.pack-one [name="lpg02product__flavour"]:checked`).attr('data-price');
  let subscription_price = $(`.pack-one [name="lpg02product__flavour"]:checked`).attr('data-subscription_price');
  let imagepath = $(`.pack-one [name="lpg02product__flavour"]:checked`).attr('data-image');
  let is_otp = true;
  if ($(".lpg-02-product__purchase-input:checked").val() !== "otp") {
    is_otp = false;
  }

  $(".pack1.lpg-02-product__item").each(function (ix, em) {
    let quantity = 1;
    let data_per_pack = otp_price;
    let data_total = otp_price * quantity;
    data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
    data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    if (is_otp == false) {
      data_per_pack = subscription_price;
      data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
      data_total = subscription_price * quantity;
      data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    }
    $(em).find('[data-perpack]').html(data_per_pack);
    $(em).find('[data-total]').html(data_total);
  });
}
function onload_set_pricing_2() {
  $('.pack-two .first-variant input[type="radio"]').prop("checked", true).trigger("click");
  let otp_price = $(`.pack-two [name="lpg02product__flavour"]:checked`).attr('data-price');
  let subscription_price = $(`.pack-two [name="lpg02product__flavour"]:checked`).attr('data-subscription_price');
  let imagepath = $(`.pack-two [name="lpg02product__flavour"]:checked`).attr('data-image');
  let is_otp = true;
  if ($(".lpg-02-product__purchase-input:checked").val() !== "otp") {
    is_otp = false;
  }

  $(".pack2.lpg-02-product__item").each(function (ix, em) {
    let quantity = 2;
    let data_per_pack = otp_price;
    let data_total = otp_price * quantity;
    data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
    data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    if (is_otp == false) {
      data_per_pack = subscription_price;
      data_per_pack = Shopify.formatMoney(data_per_pack, Shopify.money_format);
      data_total = subscription_price * quantity;
      data_total = Shopify.formatMoney(data_total, Shopify.money_format);
    }
    $(em).find('[data-perpack]').html(data_per_pack);
    $(em).find('[data-total]').html(data_total);
  });
}


function changeMySlider() {
  $(`.pack-one [name="lpg02product__flavour"]`).each(function(ix,em){
    if( $(em).prop('checked') == true) {
      $('.pro_big').slick('slickGoTo', ix);
    }
  });
  $(`.pack-two [name="lpg02product__flavour"]`).each(function(ix,em){
    if( $(em).prop('checked') == true) {
      $('.pro_big').slick('slickGoTo', ix);
    }
  });
  $(`.pack-three [name="lpg02product__flavour"]`).each(function(ix,em){
    if( $(em).prop('checked') == true) {
      $('.pro_big').slick('slickGoTo', ix);
    }
  });
  /*
    let imagepath = $(".myFlavor:checked").attr('data-image');
    $('.big-img').each(function () {
        var image_index = $(this).attr('data-slick-index');
        var slick_image = $(this).find('img').attr('data-src');
        //alert(slick_image);
        if (slick_image.indexOf(imagepath) !== -1) {
            //$('.pro_big').slick('slickGoTo',parseInt(image_index));
            $('.pro_big').slick('slickGoTo', image_index);
        }
    });
    */
}


function reChargeGetCookie(name) {
  return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2];
}

$(document).ready(function () {


  $('.lpg-02-product__one').click(function(){
    $('.pack-one').show();
    $('.pack-two').hide();
    $('.pack-three').hide();
  });
  $('.lpg-02-product__two').click(function(){
    $('.pack-one').hide();
    $('.pack-two').show();
    $('.pack-three').hide();
  });
  $('.lpg-02-product__three').click(function(){
    $('.pack-one').hide();
    $('.pack-two').hide();
    $('.pack-three').show();
  });

  /* $('.sands').click(function(){
    $('.pack-one .first-variant input[type="radio"]').prop("checked", true).trigger("click");
    $('.pack-two .first-variant input[type="radio"]').prop("checked", true).trigger("click");
    $('.pack2').click();
    $('.pack3').click();
  });*/

  $(document).on('click', '.fancybox-close-small', function (e) {

    // changes the iframe src to prevent playback or stop the video playback in our case
    $('.fitvid iframe').each(function (index) {
      $(this).attr('src', $(this).attr('src'));
      return false;
    });
  });

  changeMySlider();
});